import { privateApi } from "../api/axios";

export const getTime = async (id : number) => {
    try {
        const response = await privateApi.get(`api/times/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateTime = async (id : number, data : any) => {
    try {
        const response = await privateApi.patch(`api/times/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteTime = async (id : number) => {
    try {
        const response = await privateApi.delete(`api/times/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimesUnvalidated = async () => {
    try {
        const response = await privateApi.get(`api/times/unvalidated`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const validateTimes = async (ids : number[]) => {
    try {
        const response = await privateApi.post(`api/times/validate`, ids);
        return response;
    } catch (error) {
        throw error;
    }
}